import Tabs from '../Tabs'
import LeaderboardUserList, { User } from './LeaderboardUserList'
import Phrase from '../../libs/translationsUtils/phrase'
import { z } from 'zod'
import { FunctionalComponent } from 'preact'
import BoxWidget from '../../components/box-widget'

export const allTimeRanges: TimeRanges[] = ['thisWeek', 'allTime']

export type TimeRanges = 'thisWeek' | 'allTime'

interface CustomDisplayProps {
  maxResults: number
  timeRange: TimeRanges[]
  excludeUserRole?: string[]
  emptyMessage: string
  isPreviewEmptyMessage: boolean
  usersList?: User[]
  title: string
  showLink?: boolean
  linkText?: string
  showLoggedInUserSection?: boolean
}

export const widgetName = 'leaderboard_points'

export const config = z.object({
  maxResults: z.number(),
  timeRange: z.array(z.enum(['thisWeek', 'allTime'])),
  excludeUserRole: z.array(z.string()).optional(),
  emptyMessage: z.string(),
  isPreviewEmptyMessage: z.boolean(),
  usersList: z.array(z.object({
    id: z.number(),
    name: z.string(),
    avatar: z.string(),
    points: z.number(),
    leaderboardPosition: z.number(),
    rank: z.string().optional()
  })),
  title: z.string(),
  showLink: z.boolean(),
  linkText: z.string().optional(),
  showLoggedInUserSection: z.boolean()
})

const PointsLeaderboard: FunctionalComponent<CustomDisplayProps> = ({ timeRange, title, maxResults, usersList, excludeUserRole, emptyMessage, isPreviewEmptyMessage, showLink, linkText, showLoggedInUserSection }: CustomDisplayProps) => {
  const tabs = timeRange || allTimeRanges
  const tabTitles = tabs.map(tab => {
    return <Phrase key={tab} p={`leaderboard.points.${tab}`} />
  })
  return (
    <BoxWidget className='widget--leaderboard_points qa-widget-leaderboard_points'>
      {title ? <h3 className='widget-title'>{title}</h3> : null}
      <div className='leaderboard-container'>
        <Tabs titles={tabTitles}>
          {tabs.map(tab => <LeaderboardUserList
            key={tab}
            tabTitle={tab}
            maxResults={maxResults}
            usersList={usersList}
            excludeUserRole={excludeUserRole || []}
            emptyMessage={emptyMessage}
            isPreviewEmptyMessage={isPreviewEmptyMessage}
            showLink={showLink}
            linkText={linkText}
            showLoggedInUserSection={showLoggedInUserSection}
                           />)}
        </Tabs>
      </div>
    </BoxWidget>
  )
}

export default PointsLeaderboard
